// extracted by mini-css-extract-plugin
export default {"icon":"style_icon__1SSSD","input":"style_input__UreDy"};